// Support ("Поддержка сервиса") — ports the support-section from the original
// index.html (distinct from Psychologist). Hero + working-hours card + a CTA
// that opens the Chatwoot support chat + a list of common support questions.

import { useChatwoot } from '../../hooks/useChatwoot'
import { useAccountSegment } from '../../features/product-segment'
import { useChatwootStore } from '../../store/chatwootStore'
import styles from './Support.module.css'

const TELEGRAM_HISTORY_QUESTION = 'Как перенести историю из Telegram в приложение?'

const SUPPORT_QUESTIONS = [
  'Можно ли обсуждать с ботом конкретную тему — подойдёт ли он мне?',
  'Бот ответил странно или некорректно — куда сообщить?',
  'Не списались / задвоились деньги за подписку — что делать?',
  'Как отменить автопродление или вернуть оплату?',
  'Закончились токены раньше срока — почему?',
  'Не приходит ответ бота / не отправляется голосовое.',
  TELEGRAM_HISTORY_QUESTION,
  'Как удалить свою историю и данные?',
  'Не приходит отчёт для сессии с психологом?',
  'Как установить приложение на телефон (PWA)?',
]

export default function Support() {
  const { open: openChat } = useChatwoot()
  const cwShow = useChatwootStore((s) => s.hasConversation && !s.resolved && s.unread > 0)
  const { profile } = useAccountSegment()
  // break_up (#4480, 17.10): no Telegram bot to transfer history from —
  // the question stays for the main build only.
  const questions = profile?.segment === 'break_up'
    ? SUPPORT_QUESTIONS.filter((q) => q !== TELEGRAM_HISTORY_QUESTION)
    : SUPPORT_QUESTIONS

  return (
    <div className={styles.wrap}>
      <div className={styles.hero}>
        <div className={styles.heroIcon} aria-hidden>⚙️</div>
        <h2>Поддержка сервиса</h2>
        <p>
          Ответим на любые вопросы о Humanteq: тарифы и оплата, доступ, технические сбои, данные.
          Можно спросить и о качестве работы бота, или уточнить, стоит ли обсуждать с ботом ту или
          иную тему — в поддержке работает психолог, он поможет быстро сориентироваться.
        </p>
      </div>

      <div className={styles.hoursCard}>
        <div className={styles.hoursIcon} aria-hidden>🕐</div>
        <div>
          <div className={styles.hoursTitle}>Режим работы</div>
          <div className={styles.hoursText}>
            Отвечаем по будням с 10:00 до 18:00. Обычно в течение двух часов — часто быстрее.
          </div>
        </div>
      </div>

      <div className={styles.ctaCard}>
        <p className={styles.ctaText}>Напишите нам прямо здесь — чат откроется в приложении.</p>
        <button className={styles.chatBtn} onClick={openChat}>
          Написать в поддержку
          {cwShow && <span className={styles.unreadDot} aria-label="новые ответы" />}
        </button>
      </div>

      <div className={styles.faqList}>
        <h3>С чем чаще всего обращаются</h3>
        <p className={styles.faqHint}>
          Поддержка отвечает на вопросы о сервисе и о работе бота. Если хочется поговорить о
          состоянии — это раздел «Чат», для консультации — «Психолог».
        </p>
        {questions.map((q) => (
          <div key={q} className={styles.q}>
            <span className={styles.qNum}>?</span>
            <span>{q}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
